module.exports = __webpack_public_path__ + "img/2.ed3ceb88.jpg";